export { StyledEngineProvider as default } from '@material-ui/styled-engine';